/**
 * Implements memoized cell originated from chain/address
 */
import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { ITicker } from '@kattana-io/common';
import Text from '../../atoms/Text';
import { formatTx } from './formatters';
import useTicker from '../../hooks/useTicker';
import PairIcons from '../../molecules/PairIcons';
import { switchCurrentTicker } from '../../Authlogic';

interface IPairWithIconsProps {
  ticker: ITicker | undefined;
  path: string;
}

const TickerCell = ({ path, ticker }: IPairWithIconsProps) => {
  if (!ticker) {
    const [network, address] = path.split('-');
    return (
      <span className='ticker__cell'>
        <Link to={path}>
          <Text size={12} className='text--weight-400 text--grey-400'>
            {network}/{formatTx(address)}
          </Text>
        </Link>
      </span>
    );
  }

  const onTickerClick = useCallback(() => {
    switchCurrentTicker(ticker);
  }, [ticker]);

  const { chain, base_address, quote_address, name, base_slug, quote_slug } =
    useTicker(ticker);
  return (
    <span className='ticker__cell' onClick={onTickerClick}>
      <PairIcons
        chain={chain}
        base_address={base_address}
        quote_address={quote_address}
        base_slug={base_slug}
        quote_slug={quote_slug}
        pair={name}
      />
      <Text size={12} className='text--weight-500 text--grey-400'>
        {name}
      </Text>
    </span>
  );
};

export default TickerCell;
